import { bindSessionUser, bindWindowBranch } from '../../lib/api';
import { RUTA_LOGIN } from './login-path';
import { borrarSesion } from './sesion';
import { leerMarcaSalida, MARCA_SALIDA } from './sesion-pestanas';

export const CANAL_SALIDA = 'kapi-sesion-salida';
export const SESION_CERRADA = 'kapi:logout';
interface Salida { tipo: 'salir'; id: string }
function esSalida(data: unknown): data is Salida {
  if (!data || typeof data !== 'object') return false;
  const m = data as Partial<Salida>;
  return m.tipo === 'salir' && typeof m.id === 'string' && m.id.length > 0 && m.id.length <= 128;
}

export function crearSalidaPestanas(
  w: Window,
  limpiar: () => void,
  crearCanal: (nombre: string) => BroadcastChannel = nombre => new BroadcastChannel(nombre),
) {
  let canal: BroadcastChannel | null = null, detenido = false;
  const vistas = new Set<string>();
  const recordar = (id: string) => {
    vistas.add(id);
    if (vistas.size > 64) vistas.delete(vistas.values().next().value!);
  };
  try { const previa = JSON.parse(leerMarcaSalida(w) || 'null'); if (esSalida(previa)) recordar(previa.id); } catch { /* marca ajena */ }
  const aplicar = (data: unknown, ir = (url: string) => w.location.assign(url)) => {
    if (detenido || !esSalida(data) || vistas.has(data.id)) return;
    recordar(data.id);
    limpiar();
    ir(RUTA_LOGIN);
  };
  const storage = (e: StorageEvent) => {
    if (e.key !== MARCA_SALIDA || !e.newValue) return;
    try {
      if (e.storageArea && e.storageArea !== w.localStorage) return;
      aplicar(JSON.parse(e.newValue));
    } catch { /* almacenamiento o marca no disponibles */ }
  };
  w.addEventListener('storage', storage);
  try { canal = crearCanal(CANAL_SALIDA); canal.onmessage = e => aplicar(e.data); } catch { /* respaldo storage */ }
  return {
    cerrar(ir?: (url: string) => void) {
      if (detenido) return;
      const aviso: Salida = { tipo: 'salir', id: crypto.randomUUID() };
      // Siempre escribir: conecta pestañas con/sin canal y frena confirmaciones antes de recibir el aviso.
      try { w.localStorage.setItem(MARCA_SALIDA, JSON.stringify(aviso)); } catch { /* queda el canal */ }
      try { canal?.postMessage(aviso); } catch { /* queda storage */ }
      aplicar(aviso, ir);
    },
    detener() { detenido = true; canal?.close(); w.removeEventListener('storage', storage); },
  };
}

let salida: ReturnType<typeof crearSalidaPestanas> | undefined;
let usuarios = 0;
function obtenerSalida() {
  return salida ??= crearSalidaPestanas(window, () => {
    try { bindSessionUser(null, true); } catch { /* sin almacenamiento */ }
    bindWindowBranch(null);
    borrarSesion();
    try { localStorage.removeItem('kapi:remember_me'); } catch { /* sin almacenamiento */ }
    window.dispatchEvent(new Event(SESION_CERRADA));
  });
}

/** Se instala antes de adquirir sesión, incluso en documentos públicos y de error. */
export function instalarSalidaPestanas(): () => void {
  obtenerSalida(); usuarios++;
  return () => { if (--usuarios === 0) { salida?.detener(); salida = undefined; } };
}
export function cerrarSesionCompartida(ir?: (url: string) => void): void {
  obtenerSalida().cerrar(ir);
}
